<template>
  <div class="wechatLogin" @click="$router.push({ path: '/user/wechatLogin', replace: true })">
    <slot>
      <SvgIcon style="width: 40px; height: 40px;" :iconClass="'wechatActive'" />
    </slot>
  </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon'

export default {
  components: { SvgIcon },

  data() {
    return {}
  }
}
</script>

<style lang="less">
.wechatLogin {
  cursor: pointer;
  margin: 12px;
}
.scanWechat {
  width: 400px;
  height: 400px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
